"use strict";

const MAP_STYLES = [
    {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }],
    },
    {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{ visibility: "on" }, { color: "#ffffff" }, { lightness: 16 }],
    },
    {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
    },
    {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#fefefe" }, { lightness: 20 }],
    },
    {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
    },
    {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ color: "#dedede" }, { lightness: 21 }],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#ffffff" }, { lightness: 17 }],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }, { lightness: 18 }],
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }, { lightness: 16 }],
    },
    {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#eeeded" }, { lightness: 17 }],
    },
    {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [{ color: "#d5e7f0" }],
    },
    {
        featureType: "water",
        elementType: "geometry.stroke",
        stylers: [{ visibility: "on" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
    },
];

const MARKER_ICON = {
    url:
        "data:image/svg+xml;charset=UTF-8," +
        encodeURIComponent(
            `<svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
                <path d="M9.84923 5.62744C7.52159 5.62744 5.625 7.532 5.625 9.85754V32.3952C5.625 34.7284 7.51906 36.6203 9.84923 36.6203H32.3776C34.7103 36.6203 36.6019 34.7284 36.6019 32.3952V9.85754C36.6019 7.532 34.7103 5.62744 32.3776 5.62744C31.2138 5.62744 30.1565 6.10675 29.3933 6.87263L22.1086 14.1586C21.566 14.709 20.6811 14.709 20.1284 14.1663L12.8386 6.87263C12.078 6.10675 11.0181 5.62744 9.85177 5.62744M8.43693 9.86008C8.43693 9.08151 9.07589 8.45258 9.84923 8.45258C10.2422 8.45258 10.5921 8.60981 10.8482 8.86595L18.1278 16.1494L18.1405 16.1596L18.1582 16.1723C19.7937 17.7978 22.4357 17.7978 24.0762 16.1723H24.0788L31.3888 8.86595C31.6372 8.60981 31.9897 8.45258 32.3751 8.45258C33.1586 8.45258 33.7874 9.08405 33.7874 9.86008V32.3978C33.7874 33.1738 33.156 33.8053 32.3751 33.8053H9.84669C9.07335 33.8053 8.43439 33.1738 8.43439 32.3978V9.86008H8.43693Z" fill="#1D1D1B"/>
                <path d="M9.85062 0.00253464C4.40679 0.00253464 0 4.4203 0 9.86009V32.3978C0 37.8376 4.40679 42.2553 9.85062 42.2553H32.379C37.8279 42.2553 42.2398 37.8376 42.2398 32.4029L42.2449 9.85755C42.2449 4.41776 37.8279 0 32.379 0H9.85062V0.00253464ZM2.81446 9.86009C2.81446 5.96982 5.96869 2.81246 9.85062 2.81246H32.379C36.2686 2.81246 39.4253 5.96982 39.4253 9.86009V32.3978C39.4253 36.2906 36.2711 39.4378 32.379 39.4378H9.85062C5.96869 39.4378 2.81446 36.2906 2.81446 32.3978V9.86009Z" fill="#1D1D1B"/>
            </svg>`
        ),
    scaledSize: null,
    anchor: null,
};

function loadGoogleMaps(apiKey) {
    return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
            resolve(window.google.maps);
            return;
        }

        const existing = document.querySelector("script[data-contacts-maps]");
        if (existing) {
            existing.addEventListener("load", () => resolve(window.google.maps));
            existing.addEventListener("error", reject);
            return;
        }

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}`;
        script.async = true;
        script.defer = true;
        script.dataset.contactsMaps = "1";
        script.onload = () => resolve(window.google.maps);
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

function initContactsMap() {
    const mapEl = document.getElementById("contactsMap");
    if (!mapEl) return;

    const apiKey = mapEl.dataset.apiKey;
    const lat = parseFloat(mapEl.dataset.lat);
    const lng = parseFloat(mapEl.dataset.lng);
    const zoom = parseFloat(mapEl.dataset.zoom) || 13;

    if (!apiKey || Number.isNaN(lat) || Number.isNaN(lng)) return;

    loadGoogleMaps(apiKey)
        .then((maps) => {
            const position = { lat, lng };
            const map = new maps.Map(mapEl, {
                center: position,
                zoom,
                styles: MAP_STYLES,
                disableDefaultUI: true,
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
            });

            const icon = {
                ...MARKER_ICON,
                scaledSize: new maps.Size(43, 43),
                anchor: new maps.Point(21.5, 21.5),
            };

            new maps.Marker({
                position,
                map,
                icon,
            });
        })
        .catch(() => {
            mapEl.classList.add("is-error");
        });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initContactsMap);
} else {
    initContactsMap();
}
